module.exports = __webpack_public_path__ + "static/img/bg_lounge.e808e5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/backgrounds/thumbnail/bg_lounge.png
// module id = GDsX
// module chunks = 0